// extracted by mini-css-extract-plugin
module.exports = {"plain":"MaybeRouterLink_plain_xxPtL"};